import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var deliveryMethodSchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    active: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'inputSwitch',
        label: 'Активен',
        value: '',
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: '',
    }),
    price: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Цена *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете цена',
    }),
    delivery_type: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control category-dropdown',
            placeholder: '',
            options: [
                { label: 'econt', value: 'econt' },
                { label: 'on_site', value: 'on_site' },
                { label: 'speedy', value: 'speedy' },
                { label: 'speedy_office', value: 'speedy_office' }
            ]
        }),
        elementType: 'dropdown',
        label: 'Тип на доставка *',
        validation: {
            required: true
        },
        value: '',
        valid: false,
        touched: false,
        hidden: true
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
};
export default deliveryMethodSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/deliveryMethodSchema.ts
// module id = 342
// module chunks = 0